var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreatecoupon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.59 9.58L9.59 0.58C9.95 0.22 10.45 0 11 0H18C19.1 0 20 0.9 20 2V9C20 9.55 19.78 10.05 19.41 10.42L10.41 19.42C10.05 19.78 9.55 20 9 20C8.45 20 7.95 19.78 7.59 19.41L0.59 12.41C0.22 12.05 0 11.55 0 11C0 10.45 0.23 9.94 0.59 9.58ZM16.5 5C17.33 5 18 4.33 18 3.5C18 2.67 17.33 2 16.5 2C15.67 2 15 2.67 15 3.5C15 4.33 15.67 5 16.5 5Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatecoupon);
export default __webpack_public_path__ + "static/media/Create coupon.b176420af8bcc820be3a9c7a44a989b4.svg";
export { ForwardRef as ReactComponent };